import script from "./ObjectsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectsList.vue?vue&type=script&setup=true&lang=js"

import "./ObjectsList.vue?vue&type=style&index=0&id=0d8d9ac6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8d9ac6"]])

export default __exports__